module.exports = __webpack_public_path__ + "static/headerbanner_v19_2023-12-04-f324f22e891b3bc3b7e551b52c62a1d6.jpg";